import Allergens from './allergens';

export default Allergens;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Allergens/index.js